import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormHelperText,
  InputLabel,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Input,
  Grid,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
// import socketIoClient from '../../../socket/socketConfig';
import moment from 'moment';
import * as api from '../../../services/api/admin';
import './daystyle.css';

function CancellationModal(props) {
  const {
    open,
    onClose,
    selectedApptInfo,
    refeshAppointments,
    apptCountUpdate,
    currentUserId,
    classes: { dialogFooter, action, input, warning, cancelText },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [cancelReason, setCancelReason] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [disableButton, setDisableButton] = useState(false);
  const [reasonOfCancelAppt, setReasonOfCancelAppt] = useState('');

  useEffect(() => {
    if (cancelReason === 'No show/DNKA') {
      setReasonOfCancelAppt('');
    }
  }, [cancelReason]);

  const cancel = async () => {
    try {
      if (validate()) {
        setDisableButton(true);
        await api.cancelAppointmentFromAdmin(
          selectedApptInfo.id,
          cancelReason,
          reasonOfCancelAppt
        );
        refeshAppointments(selectedApptInfo.providerId);
        onClose();
        if (apptCountUpdate) {
          apptCountUpdate();
        }
        // socketIoClient.emit('message', {
        //   message: 'auto-refresh-Appointments',
        //   id: currentUserId,
        // });
        setCancelReason('');
        setReasonOfCancelAppt('');
        setDisableButton(false);

        // if (result && result.data === 'Already appointment cancelled') {
        //   enqueueSnackbar('Already appointment cancelled');
        // } else {
        enqueueSnackbar('Appointment cancelled successfully.', {
          preventDuplicate: true,
          autoHideDuration: 3000,
        });
        // }
      }
    } catch (err) {
      enqueueSnackbar('Failed to cancel appointment. Please try again.');
    }
  };

  /** Different arrays for different dropdowns */
  const cancelByPractice = [
    'Appointment not needed',
    'Patient arrived late',
    'Earlier Appointment needed',
    'Later appointment needed',
    'Other',
  ];
  const cancelByPatient = [
    'Appointment not needed',
    'Appointment moved earlier',
    'Appointment moved later',
    'Running Late',
    'Other',
  ];
  const noShow = [''];

  /** Type variable to store different array for different dropdown */
  let type = null;

  /** This will be used to create set of options that user will see */
  let option = null;

  /** Setting Type variable according to dropdown */
  if (cancelReason === 'Cancelled by practice') {
    type = cancelByPractice;
  } else if (cancelReason === 'Cancelled by patient') {
    type = cancelByPatient;
  } else if (cancelReason === 'No show/DNKA') {
    type = noShow;
  }

  /** If "Type" is null or undefined then options will be null,
   * otherwise it will create a options iterable based on our array
   */
  if (type) {
    option = type.map(el => <option key={el}>{el}</option>);
  }

  const validate = () => {
    let valid = true;
    const nextState = {};
    if (!cancelReason) {
      nextState.cancelReason = 'Required';
      valid = false;
    }
    if (cancelReason !== 'No show/DNKA') {
      if (!reasonOfCancelAppt) {
        nextState.reasonOfCancelAppt = 'Required';
        valid = false;
      }
    }
    setValidationErrors(nextState);
    return valid;
  };

  const cancelReasonList = [
    {
      id: 1,
      name: 'Cancelled by practice',
    },
    {
      id: 2,
      name: 'Cancelled by patient',
    },
    {
      id: 3,
      name: 'No show/DNKA',
    },
  ];

  return (
    <>
      <Dialog fullWidth open={open} onClose={onClose} maxWidth="md">
        <DialogTitle>Cancel Appointment</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Cancel the appointment with {selectedApptInfo.patientName} at{' '}
            {moment(selectedApptInfo.time).format('MMMM Do YYYY, h:mm a')} ?
          </Typography>

          <div className="res-full-width">
            <InputLabel className={cancelText}>
              Select a Cancel Reason
            </InputLabel>
            <Select
              fullWidth
              variant="outlined"
              // placeholder="cancel Reason"
              name="cancelReason"
              value={cancelReason}
              label="Cancel Reason"
              onChange={event => {
                setCancelReason(event.target.value);
                setValidationErrors({
                  ...validationErrors,
                  [event.target.name]: false,
                });
              }}
              error={!!validationErrors.cancelReason}
              className={input}
            >
              {cancelReasonList.map(items => (
                <MenuItem key={`menu-${items.id}`} value={items.name}>
                  <ListItemText primary={items.name} />
                </MenuItem>
              ))}
            </Select>
            {validationErrors.cancelReason && (
              <Typography className={warning}>Required</Typography>
            )}
          </div>
          <div />
          {cancelReason && cancelReason !== 'No show/DNKA' ? (
            <div className="res-full-width">
              <InputLabel className={cancelText}>Select a Reason of</InputLabel>
              <Select
                fullWidth
                variant="outlined"
                name="reasonOfCancelAppt"
                value={reasonOfCancelAppt}
                onChange={event => {
                  setReasonOfCancelAppt(event.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    [event.target.name]: false,
                  });
                }}
                error={!!validationErrors.reasonOfCancelAppt}
                className={input}
              >
                {option.map(items => (
                  <MenuItem key={`menu-${items.id}`} value={items.key}>
                    <ListItemText primary={items.key} />
                  </MenuItem>
                ))}
              </Select>
              {validationErrors.reasonOfCancelAppt && (
                <Typography className={warning}>Required</Typography>
              )}
            </div>
          ) : (
            ''
          )}
        </DialogContent>

        <DialogActions className={dialogFooter}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className={action}
          >
            Back
          </Button>
          <Button
            onClick={cancel}
            variant="outlined"
            color="secondary"
            disabled={disableButton}
            className={action}
          >
            Cancel Appointment
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const styles = () => ({
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  button: {
    backgroundColor: '#424B5A',
    color: 'white',
  },
  action: {
    marginLeft: '5px',
  },
  danger: {
    color: '#F44336',
  },
  input: {
    margin: '0.5em 0',
    width: '40%',
    height: '45px',
  },
  warning: {
    color: '#e25141',
    fontSize: '12px',
  },
  cancelText: {
    fontWeight: 'bold',
    color: '#000',
    marginTop: '15px',
  },
});

export default withStyles(styles)(CancellationModal);
